import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import { Grid, Typography, CircularProgress } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { authActions } from '_state/actions'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(4),
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    },
    loader: {
        marginTop: theme.spacing(2),
    },
}))

const TwoFactorCallbackPage = (props) => {
    const classes = useStyles()
    const location = useLocation()
    const history = useHistory()

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const token = params.get('token')

        if (token) {
            try {
                let tokenData
                if (typeof token === 'string' && token.startsWith('{')) {
                    tokenData = JSON.parse(token)
                } else if (typeof token === 'string') {
                    tokenData = { token }
                } else {
                    tokenData = token
                }
                localStorage.setItem('authToken', JSON.stringify(tokenData))
                props.twoFactorCompleted(tokenData)
            } catch (e) {
                history.replace('/login')
            }
        } else {
            history.replace('/login')
        }
    }, [location.search, history, props])

    return (
        <Grid container className={classes.container}>
            <Typography variant="body1">
                <FormattedMessage
                    id="dashboard.auth.2fa.completing"
                    defaultMessage="Completing sign in..."
                />
            </Typography>
            <CircularProgress className={classes.loader} size={30} />
        </Grid>
    )
}

TwoFactorCallbackPage.propTypes = {}

const mapDispatchToProps = (dispatch) => ({
    twoFactorCompleted: (tokenData) => dispatch(authActions.twoFactorCompleted(tokenData)),
})

export default connect(null, mapDispatchToProps)(TwoFactorCallbackPage)
